import fetch from 'node-fetch'
import React, { SyntheticEvent, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import assets from '../admin/crudFunctions/assets'
import { paymentPayload, postHeaders } from '../interfaces'

const Verification = () => {
  const [showButton, setShowButton] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const history: any = useHistory()
  const form: any = history.location.state.form
  const dateArray: string[] = form.date.split('-') // splits de date into chunks
  const formatedDate: string = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`

  const postPayment = async (
    payload: paymentPayload
  ): Promise<boolean | undefined> => {
    const url: string = assets.serverlessUrl + 'postData'
    const endpoint: string = 'payment/create'
    const headers: postHeaders = {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        endpoint: endpoint,
        payload: payload
      })
    }

    try {
      const response = await fetch(url, headers)

      if (response.status >= 200 && response.status <= 299) {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleSubmit = async (e: SyntheticEvent): Promise<void> => {
    e.preventDefault()
    setIsLoading(true)
    const payload: paymentPayload = {
      client: form.client.id,
      method: form.method,
      transaction_number: form.transaction_number,
      location: form.location === '' ? '' : form.location.id,
      amount: form.amount,
      date: form.date
    }
    const paymentResponse: boolean | undefined = await postPayment(payload)
    setIsLoading(false)
    history.push({
      pathname: '/finish',
      state: { success: paymentResponse }
    })
  }

  const handleChange = (): void => {
    setShowButton(!showButton)
  }

  return (
    <React.Fragment>
      {isLoading ? (
        <div className='container grid justify-items-center md:mx-auto'>
          <div className='loader animate-spin mt-52'></div>
        </div>
      ) : (
        <>
          <div className='container grid justify-items-center md:mx-auto'>
            <h2 className='mt-14 mb-5 text-3xl text-center w-full leading-6'>
              Por favor verifica la información a continuación
            </h2>
            <div className='grid grid-cols-3'>
              <div className='grid justify-items-start'>
                <h2 className='mt-10 mb-5 text-2xl w-11-12'>Nombre:</h2>
                <h2 className='mb-5 text-2xl w-11-12'>Teléfono:</h2>
                <h2 className='mb-5 text-2xl w-11-12'>Método:</h2>
                {form.location && (
                  <h2 className='mb-5 text-2xl w-11-12'>Direccion:</h2>
                )}
                {form.transaction_number && (
                  <h2 className='mb-5 text-2xl w-11-12'>Referencia:</h2>
                )}
                <h2 className='mb-5 text-2xl w-11-12'>Monto:</h2>
                <h2 className='mb-5 text-2xl w-11-12'>Fecha:</h2>
              </div>
              <div className='grid justify-items-center col-span-2'>
                <h2 className='mt-10 mb-5 text-2xl w-11-12'>
                  {form.client.name}
                </h2>
                <h2 className='mb-5 text-2xl w-11-12'>{form.client.phone}</h2>
                <h2 className='mb-5 text-2xl w-11-12'>{form.method}</h2>
                <h2 className='mb-5 text-2xl w-11-12 text-center'>
                  {form.location.address || form.transaction_number}
                </h2>
                <h2 className='mb-5 text-2xl w-11-12'>{form.amount}</h2>
                <h2 className='mb-5 text-2xl w-11-12'>{formatedDate}</h2>
              </div>
            </div>

            <form
              className='w-10/12 mt-5 grid grid-cols-4 gap-4 mx-auto'
              onSubmit={handleSubmit}>
              <input
                type='checkbox'
                name='confirmed'
                id='confirmed'
                className='mt-3 h-12 w-12 md:place-self-end'
                onChange={handleChange}
              />
              <label
                htmlFor='confirmed'
                className='text-2xl text-left col-span-3 leading-6 md:align-text-bottom md:mt-5'>
                Confirmo que la información de este pago es correcta
              </label>
              {showButton && (
                <button
                  type='submit'
                  className='bg-black active:bg-gray-800 rounded-full h-14 w-80 text-center md:place-self-center text-white text-3xl mt-5 md:col-span-4'>
                  Registrar Pago
                </button>
              )}
            </form>
            <Link to='/'>
              <button
                type='button'
                className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-3xl mt-20'>
                Cancelar
              </button>
            </Link>
          </div>
        </>
      )}
    </React.Fragment>
  )
}

export default Verification
